import { snackbarBus } from "../main";

export const showPopup = function (text, color) {
  snackbarBus.$emit("createsnackbar", {
    text: text,
    color: color,
  });
};
